/* Virtusx redesign: applies window.VX_CONFIG (printed by layout/rd.liquid from the theme settings). Source: design assets/js/site-config.js */
/* ---- applies the settings above; nothing to edit below this line ---- */
(function () {
  var C = window.VX_CONFIG;
  // the draft switch, as a class on <html> (site.css hides the draft note when it is .vx-live)
  if (!C.DRAFT) document.documentElement.classList.add('vx-live');

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    // footer social links
    Object.keys(C.SOCIAL || {}).forEach(function (k) {
      var url = C.SOCIAL[k]; if (!url) return;
      document.querySelectorAll('.f-social a[aria-label="Virtusx on ' + k + '"]').forEach(function (a) {
        a.href = url; a.target = '_blank'; a.rel = 'noopener';
      });
    });
    // Join the community: also send the email (the page's own script still shows the tick)
    if (C.JOIN_ENDPOINT) {
      var f = document.getElementById('join');
      if (f) f.addEventListener('submit', function () {
        var inp = f.querySelector('input[type=email]'); if (!inp || !inp.checkValidity()) return;
        var data = new FormData(); data.append(C.JOIN_FIELD || 'email', inp.value);
        Object.keys(C.JOIN_EXTRA || {}).forEach(function (k) { data.append(k, C.JOIN_EXTRA[k]); });
        try { fetch(C.JOIN_ENDPOINT, { method: 'POST', body: data, mode: 'no-cors' }); } catch (e) {}
      }, true);   // capture: runs before the page's own handler empties the box
    }
  });
})();
